import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from '@heroui/react';
import type { Marca } from '@/types/marca.model';

interface DeleteMarcaModalProps {
  isOpen: boolean;
  onClose: () => void;
  onDelete: (id: string | number) => Promise<void>;
  marca?: Marca;
}

const DeleteMarcaModal = ({ isOpen, onClose, onDelete, marca }: DeleteMarcaModalProps) => {
  const handleDelete = async () => {
    if (marca?.id) {
      await onDelete(marca.id);
      onClose();
    }
  };

  return (
    <Modal 
      isOpen={isOpen} 
      onClose={onClose}
      placement="top-center"
      backdrop="blur"
    >
      <ModalContent>
        {(onClose) => (
          <>
            <ModalHeader className="flex flex-col gap-1">Eliminar Marca</ModalHeader>
            <ModalBody>
              <p>¿Está seguro que desea eliminar la marca <strong>{marca?.nombre}</strong>? Esta acción no se puede deshacer.</p>
            </ModalBody>
            <ModalFooter>
              <Button 
                color="danger" 
                variant="light" 
                onPress={onClose}
              >
                Cancelar
              </Button>
              <Button 
                color="primary" 
                onPress={handleDelete}
              >
                Eliminar
              </Button>
            </ModalFooter>
          </>
        )}
      </ModalContent>
    </Modal>
  );
};

export default DeleteMarcaModal;